import { HIDROTEST_UYARI_KALIPLARI } from "./hidrotest.js";
/** Dönüşüm işinin belge türü (`donusum_isi.belge_turu`). İki cins (sertifika, kabul formu) tek türdür. */
export const SARF_BELGE_TURU = "sarf_belgesi";
/** Okunan Documents türleri (GELEN_TURLERI anahtarları; Registers grubu, kütük sınıfı). */
export const SARF_SERTIFIKA_GELEN_TURU = "kutuk:sarf:en10204_31";
export const SARF_KABUL_GELEN_TURU = "kutuk:sarf:kabul_formu";
export const sarfBelgesiGelenTuruMu = (t) => t === SARF_SERTIFIKA_GELEN_TURU || t === SARF_KABUL_GELEN_TURU;
export const sarfCinsi = (t) => (t === SARF_SERTIFIKA_GELEN_TURU ? "sertifika" : t === SARF_KABUL_GELEN_TURU ? "kabul" : null);
/** Cinsin sarf kütüğündeki belge türü (`GelenHedef.belgeTuru`). */
export const SARF_CINS_KUTUK_TURU = { sertifika: "en10204_31", kabul: "kabul_formu" };
/** Olay kaydında nesne tipi (nesneId = sarf_belgesi_kaydi.id). */
export const SARF_OLAY_NESNESI = "sarf_belgesi_kaydi";
/** Okunan hafif excel'in belge ailesi. Hiçbir aile sorgusu bu adı almaz (Riser Documentation, kanıt zinciri ve aile işlemleri). */
export const SARF_GIRDI_AILESI = "Consumable-document-input";
/** DOCUMENT sayfasındaki "Document type" değerleri. */
export const SARF_SERTIFIKA_EXCEL_ADI = "Consumable certificate";
export const SARF_KABUL_EXCEL_ADI = "Consumable receiving form";
/** Okuma işi kodu ("CONS-5A1B2C3D"); "SARF-" uyarı kodlarından ayrı. */
export const sarfKodu = (kayitId) => `CONS-${kayitId.replace(/-/g, "").slice(0, 8).toUpperCase()}`;
/** Sertifikanın alanları (DOCUMENT, 8; sabit sıra; sözleşme §10.3, sürüm 1). `etiket` hem ekran metni hem DOCUMENT'teki Field adıdır. Kimlik: sertifika no ve lot. */
export const SARF_SERTIFIKA_ALANLARI = [
    { alan: "sertifika_no", etiket: "Certificate number", kimlik: true }, { alan: "uretici", etiket: "Manufacturer", kimlik: false },
    { alan: "tarih", etiket: "Certificate date", kimlik: false }, { alan: "lot", etiket: "Lot", kimlik: true },
    { alan: "sinif", etiket: "AWS classification", kimlik: false }, { alan: "heat", etiket: "Heat", kimlik: false },
    { alan: "urun_no", etiket: "Product number", kimlik: false }, { alan: "cap", etiket: "Diameter", kimlik: false },
];
/** Kabul formunun alanları (DOCUMENT, 5; sabit sıra; sözleşme §10.3). Kimlik: lot. */
export const SARF_KABUL_ALANLARI = [
    { alan: "teslim_tarihi", etiket: "Received on", kimlik: false }, { alan: "karar", etiket: "Decision", kimlik: false },
    { alan: "lot", etiket: "Lot", kimlik: true }, { alan: "heat", etiket: "Heat", kimlik: false }, { alan: "urun_no", etiket: "Product number", kimlik: false },
];
/** Alanın ekran adı (iki listede aranır); bilinmiyorsa alanın kendisi. */
export const sarfEtiketi = (alan) => [...SARF_SERTIFIKA_ALANLARI, ...SARF_KABUL_ALANLARI].find((a) => a.alan === alan)?.etiket ?? alan;
/** `Decision` hücresinin yalnız iki değeri. */
export const KABUL_KARARLARI = { kabul: "Accepted", ret: "Rejected" };
/** Kişinin "Record on the lot" onayının alanı (`belge_deger_onayi.alan`; parça 1, alan başına bir kez). */
export const SARF_KAYIT_ALANI = { teslim_tarihi: "lot_teslim_tarihi", cap: "lot_cap" };
/** Kayıt alanının okunduğu cins: Received on yalnız kabul formundan, Diameter yalnız sertifikadan. */
export const SARF_KAYIT_CINSI = { teslim_tarihi: "kabul", cap: "sertifika" };
/** SARF-01'in yakın lot olmadan yalın kalıbı. */
export const SARF01_YALIN_KALIBI = "Lot not in Registers: {0}.";
/* ---------------- değer biçimleri (yalnız kesin değerler kullanılır) ---------------- */
/** Lot numarasının karşılaştırma anahtarı: kırpılır, büyük harf (weld map WM-02/WM-07'nin lot karşılaştırmasıyla aynı). */
export const sarfLotSade = (v) => (v ?? "").trim().toUpperCase();
/** Heat ve ürün no'nun karşılaştırma anahtarı: kırpılır, büyük harf, bütün boşluklar atılır. */
export const kimlikSade = (v) => (v ?? "").trim().toUpperCase().replace(/\s+/g, "");
/** İki sade metin arasındaki düzenleme mesafesi tam 1 mi (bir harf değişik, eksik ya da fazla). Eşit metin false. */
export function tekHarfFarkli(a, b) {
    if (a === b)
        return false;
    if (Math.abs(a.length - b.length) > 1)
        return false;
    if (a.length === b.length) {
        let fark = 0;
        for (let i = 0; i < a.length; i++)
            if (a[i] !== b[i] && ++fark > 1)
                return false;
        return fark === 1;
    }
    const [k, u] = a.length < b.length ? [a, b] : [b, a];
    let i = 0;
    while (i < k.length && k[i] === u[i])
        i++;
    return k.slice(i) === u.slice(i + 1);
}
/** `Decision` yazısı: yalnız tam "Accepted" / "Rejected" (büyük-küçük harfe duyarsız); öteki her yazım null. */
export function kabulKarariOku(v) {
    const s = (v ?? "").trim().toLowerCase();
    if (s === KABUL_KARARLARI.kabul.toLowerCase())
        return "kabul";
    if (s === KABUL_KARARLARI.ret.toLowerCase())
        return "ret";
    return null;
}
const CAP = /^\d{1,2}(\.\d{1,2})?$/;
/** `Diameter` değeri (milimetre, ondalık nokta, en çok iki hane ve iki ondalık, sıfırdan büyük); öteki her yazım null. */
export function capOku(v) {
    const s = (v ?? "").trim();
    if (!CAP.test(s))
        return null;
    const n = Number(s);
    return n > 0 ? n : null;
}
/** SARF-06'nın kimlik metni: lot, sonra yalnız farklı alanlar ("999L0001 · heat 999H0010 · product no. 9990002"). */
export function sarfKimlikMetni(lot, fark) {
    return `${lot}${fark.heat !== undefined ? ` · heat ${fark.heat}` : ""}${fark.urunNo !== undefined ? ` · product no. ${fark.urunNo}` : ""}`;
}
/* ---------------- uyarılar ---------------- */
/** Kartta üretilen kodlar (üretim sırası: kırmızı, kırmızı, kırmızı, sarı). Hiçbiri KAPALI_UYARI_KODLARI'nda olamaz (test). */
export const SARF_UYARI_KODLARI = ["SARF-01", "SARF-02", "GEN-02", "SARF-06"];
/** Uyarı kalıpları (İngilizce anahtar; Türkçesi sözlükte). SARF-01 yakın lot yoksa `SARF01_YALIN_KALIBI` ile yazılır. GEN-02 öteki okuyucularınkiyle aynıdır. */
export const SARF_UYARI_KALIPLARI = {
    "SARF-01": "Lot not in Registers: {0}. Closest: {1}.",
    "SARF-02": "Classification differs from the register: {0} / {1}.",
    "GEN-02": HIDROTEST_UYARI_KALIPLARI["GEN-02"],
    "SARF-06": "Receiving form lot {0} differs from the certificate lot {1}.",
};
//# sourceMappingURL=sarf.js.map